export const token_addresses = {
  emojiFlagAddress:"0x4B71cC6c98182b803a15f2bdCf4c3cBF4C3035A3"
}
